'use client';

import { useRouter } from 'next/navigation';
import { BsXCircle } from 'react-icons/bs';

export default function CloseButton() {
  const router = useRouter();

  return (
    <button className='absolute -right-4 -top-4 rounded-full bg-white p-px text-4xl text-black shadow-[0px_3px_6px_0px_rgb(0_0_0_/_60%)]' onClick={() => {
      router.back();
    }}>
      <BsXCircle />
    </button>
  );
}
